<template>
  <div class="container" @click="doCopy()">
    <mobileA
      v-if="!isPC && version === 'A'"
      class="mobile"
      :os="os"
      @getApkInfo="handleGetApkInfo"
      @getApkInfoApi="getApkInfoApi"
      :shopIosDownUrl="shopIosDownUrl"
      :configs="configs"
      :ip="ip"
      :switchData="switchData"
      :version="version"
      style="height:100%"
    ></mobileA>
    <mobileB
      v-else-if="!isPC"
      class="mobile"
      :os="os"
      :version="version"
      :qr-img="QRImg"
      @getApkInfo="handleGetApkInfo"
      @getApkInfoApi="getApkInfoApi"
      :shopIosDownUrl="shopIosDownUrl"
      :configs="configs"
      :ip="ip"
      :switchData="switchData"
      style="height:100%"
    ></mobileB>
    <tips
      v-else-if="isPC && page_pc_url === 'https://sisqd.com/?dc=THD2'"
    ></tips>
    <pcA
      v-else-if="version === 'A'"
      class="pc"
      :qr-img="QRImg"
      :os="os"
      @getApkInfo="handleGetApkInfo"
      :configs="configs"
      :version="version"
    ></pcA>
    <pcB
      v-else
      class="pc"
      :qr-img="QRImg"
      :os="os"
      @getApkInfo="handleGetApkInfo"
      :configs="configs"
    ></pcB>
    <!-- loading-->
    <div class="loading_box" v-if="isLoading && !isPC">
      <div style="height: 5px"></div>
      <div class="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <h3>加载中...</h3>
    </div>
    <selectLinePopup
      :apiUrls="apiUrls"
      :showOverlay="showOverlay"
      @selectLine="selectLine"
    ></selectLinePopup>
  </div>
</template>
<script>
import getApkInfo from "@/api/getApkInfo";
import getButtonlist from "@/api/getTemplate";
import userAgent from "@/utils/userAgent";
import QRCode from "qrcode";
import axios from "@/utils/request.js";
import mobileA from "./components/mobileA";
import mobileB from "./components/mobileB";
import pcA from "./components/pcA";
import pcB from "./components/pcB";
import tips from "./components/tips";
import selectLinePopup from "./components/selectLinePopup";
import { getTraceId, landingPageView } from "@/utils/eventTracker";
export default {
  components: {
    pcA,
    pcB,
    mobileA,
    mobileB,
    tips,
    selectLinePopup
  },
  data() {
    return {
      type: "",
      QRImg: "",
      os: "",
      param: "",
      cutInfo: {}, //替换url参数对象内<key> dc内容;
      ip: "",
      switchData: {},
      page_pc_url: "",
      iosDownUrl: "",
      androidDownUrl: "",
      storeAndroidDownUrl: "",
      channelApkAndDownUrl: "",
      isLoading: false,
      apiUrls: JSON.parse(process.env.VUE_APP_BASE_HOSTS), // api数组
      showOverlay: false, // 显示选线弹窗
      configs: [],
      shopIosDownUrl: "", // 商店包链接
      version: "A", // 当前测试阶段锁定七夕 A 版
      trace_id: getTraceId(),
      copyGestureArmed: false
    };
  },

  computed: {
    isPC() {
      return this.os.isPc;
    }
  },
  created() {
    this.getPcUrl();
    this.os = userAgent();
    this.initVersion();
    this.functionParam();
    this.getButtonlist();
    // 上报落地页展示
    landingPageView(this).catch(() => undefined);
    const referrer = document.referrer;
    if (referrer) {
      sessionStorage.setItem("referrer", referrer);
    }
    if (this.$route.query.dc) {
      sessionStorage.setItem("dc", this.$route.query.dc);
    }
    // this.getIp();
  },
  mounted() {
    this.getQRImg();
  },
  methods: {
    isDcMatch(value) {
      const reg = /^(?:ky(?:(?:0[1-9]|[1-9][0-9]|100))|TLGG(?:(?:0[1-9]|1[0-9]|2[0-9]|3[0-9]|4[0-9]|5[0-6]))|erra(?:(?:0[1-9]|10)))$/;
      return reg.test(value);
    },
    getPcUrl() {
      this.page_pc_url = window.location.href;
    },
    // 确定 A/B 版本：URL 带 version/landingVersion 测试参数时按其取值，否则随机
    initVersion() {
      const query = this.$route.query || {};
      const urlVersion = query.version || query.landingVersion;
      if (urlVersion === "A" || urlVersion === "B") {
        this.version = urlVersion;
      } else {
        this.version = Math.random() < 0.5 ? "A" : "B";
      }
    },
    //1.判断进来的url地址 替换到需要手动设置的参数 如cd
    functionParam() {
      // 剔除 version/landingVersion 等测试参数，避免混入 channel 传给模板接口
      const query = { ...(this.$route.query || {}) };
      delete query.version;
      delete query.landingVersion;
      this.param = query;
    },
    //2.获取按钮状态信息
    async getButtonlist() {
      this.isLoading = true;
      try {
        let param_btn_list = {
          appId: 205,
          channel: JSON.stringify(this.param),
          domain: window.location.protocol + "//" + window.location.host,
          version: this.version
        };
        const res = await getButtonlist(param_btn_list);
        if (res.data.code === 200) {
          this.switchData = res.data.data;
          this.configs = res.data.data.configs || [];
          this.androidDownUrl = res.data.data.androidDownUrl;
          this.storeAndroidDownUrl = res.data.data.storeAndroidDownUrl;
          this.channelApkAndDownUrl = res.data.data.channelApkAndDownUrl;
          this.iosDownUrl = res.data.data.iosDownUrl;
          // 是ios的时候才赋值
          if (this.os.isPhone) {
            this.shopIosDownUrl = res.data.data.shopIosDownUrl;
          }
        } else {
          alert(`请求失败 -- ${res.data.tip}`);
        }
        this.isLoading = false;
      } catch (err) {
        this.showOverlay = true;
        this.isLoading = false;
      }
    },
    //3. 获取外网IP地址
    getIp() {
      axios.get("https://api.ipify.org/?format=json").then(res => {
        this.ip = res.data.ip;
      });
    },
    //4. 点击下载按钮获取apk信息并下载
    async handleGetApkInfo(type) {
      await this.doCopy();
      let terminal;
      if (type === "ios" || type == "iosShop") {
        terminal = "ios";
      } else if (type == "androidSpare") {
        terminal = "androidSpare";
      } else {
        terminal = "android";
      }

      setTimeout(() => {
        if (type == "iosShop") {
          window.location.href = this.shopIosDownUrl;
        } else if (terminal === "android" || terminal === "androidSpare") {
          let dc = this.$route.query.dc;
          if (this.storeAndroidDownUrl && this.isDcMatch(dc)) {
            let url = this.channelApkAndDownUrl || this.storeAndroidDownUrl;
            window.location.href = url;
          } else if (terminal === "androidSpare") {
            window.location.href = this.androidDownUrl;
          } else {
            let jumpUrl = this.channelApkAndDownUrl || this.androidDownUrl;
            window.location.href = jumpUrl;
          }
        } else {
          let dc = this.$route.query.dc;
          let ch = this.$route.query.ch;
          let pc = this.$route.query.pc;
          let linkUrl = "";
          if (dc) {
            linkUrl = `${this.iosDownUrl}?dc=${dc}&tid=${this.trace_id}`;
          } else if (ch) {
            linkUrl = `${this.iosDownUrl}?ch=${ch}&tid=${this.trace_id}`;
          } else if (pc) {
            linkUrl = `${this.iosDownUrl}?pc=${pc}&tid=${this.trace_id}`;
          } else {
            linkUrl = `${this.iosDownUrl}?tid=${this.trace_id}`;
          }
          window.location.href = linkUrl;
          // setTimeout(() => {
          //   const appVersion = navigator.appVersion;
          //   const IOSversion = appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
          //   if (IOSversion.length > 0 && parseInt(IOSversion[1]) >= 17) {
          //     alert(
          //       "当前设备系统版本过高，请手动打开 系统配置->通用->VPN与设备管理，手动安装描述文件"
          //     );
          //   } else {
          //     window.location.href =
          //       "https://df6.gepqjpb.cc/js/embedded.mobileprovision?v=1";
          //   }
          // }, 2000);
        }
      }, 500);
    },
    // 6.剪贴板
    doCopy() {
      let req = JSON.stringify({
        ...this.$route.query,
        tid: getTraceId()
      });
      this.$copyText(req).then(
        () => undefined,
        () => {
          // 无用户手势时（如自动下载触发）浏览器会拦截复制，等首次触摸/点击补复制
          this.armCopyOnGesture();
        }
      );
    },
    // 挂一次性全局手势监听补复制；capture 阶段执行，不受子组件 stopPropagation 影响
    armCopyOnGesture() {
      if (this.copyGestureArmed) return;
      this.copyGestureArmed = true;
      const retry = () => {
        document.removeEventListener("touchend", retry, true);
        document.removeEventListener("click", retry, true);
        this.copyGestureArmed = false;
        this.doCopy();
      };
      document.addEventListener("touchend", retry, true);
      document.addEventListener("click", retry, true);
    },
    getApkInfoApi(type) {
      let terminal;
      let packageType;
      if (type === "ios") {
        terminal = "ios";
        packageType = 1;
      } else if (type == "iosShop") {
        terminal = "ios";
        packageType = 2;
      } else {
        terminal = "android";
      }
      const param = {
        appId: 205,
        ip: this.ip ? this.ip : "", //获取ip地址
        channel: JSON.stringify({
          ...this.param,
          ...this.cutInfo
        }),
        domain: window.location.protocol + "//" + window.location.host,
        terminal,
        packageType,
        version: this.version
      };
      getApkInfo(param);
    },

    //5.生成二维码
    getQRImg() {
      const color = this.type === "xingba" ? "#fb4b15" : "";
      QRCode.toDataURL(window.location.href, {
        width: 240,
        margin: 1,
        maskPattern: 1,
        scale: 1,
        color: {
          dark: color || "#000000",
          light: "#ffffff"
        }
      }).then(url => {
        const regex = /code=/gi;
        if (url.indexOf("code=") != -1) {
          this.QRImg = url.replace(regex, "pc=");
        } else {
          this.QRImg = url;
        }
      });
    },
    // 选线
    selectLine(item) {
      axios.defaults.baseURL = item; // 更改apiURL
      setTimeout(() => {
        this.showOverlay = false;
        this.loading = true;
        this.getButtonlist(); // 重新请求接口
      }, 300);
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  overflow: hidden;
  height: 100%;
  .mobile {
    height: 100%;
  }
}
/* loading */
.loading_box {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  // top: 50%;
  // left: 50%;
  // margin-left: -75px;
  // margin-top: -75px;
  // width: 150px;
  // height: 150px;
  background: rgba(0, 0, 0, 0.7);
  z-index: 99999;
  border-radius: 20px;
  display: flex;

  flex-direction: column;
  align-items: center;
  justify-content: center;

  h3 {
    padding-top: 10px;
    font-size: 20px;
    color: #fff;
  }
}

.lds-roller {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}

.lds-roller div {
  animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  transform-origin: 40px 40px;
}

.lds-roller div:after {
  content: " ";
  display: block;
  position: absolute;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #fff;
  margin: -4px 0 0 -4px;
}

.lds-roller div:nth-child(1) {
  animation-delay: -0.036s;
}

.lds-roller div:nth-child(1):after {
  top: 63px;
  left: 63px;
}

.lds-roller div:nth-child(2) {
  animation-delay: -0.072s;
}

.lds-roller div:nth-child(2):after {
  top: 68px;
  left: 56px;
}

.lds-roller div:nth-child(3) {
  animation-delay: -0.108s;
}

.lds-roller div:nth-child(3):after {
  top: 71px;
  left: 48px;
}

.lds-roller div:nth-child(4) {
  animation-delay: -0.144s;
}

.lds-roller div:nth-child(4):after {
  top: 72px;
  left: 40px;
}

.lds-roller div:nth-child(5) {
  animation-delay: -0.18s;
}

.lds-roller div:nth-child(5):after {
  top: 71px;
  left: 32px;
}

.lds-roller div:nth-child(6) {
  animation-delay: -0.216s;
}

.lds-roller div:nth-child(6):after {
  top: 68px;
  left: 24px;
}

.lds-roller div:nth-child(7) {
  animation-delay: -0.252s;
}

.lds-roller div:nth-child(7):after {
  top: 63px;
  left: 17px;
}

.lds-roller div:nth-child(8) {
  animation-delay: -0.288s;
}

.lds-roller div:nth-child(8):after {
  top: 56px;
  left: 12px;
}

@keyframes lds-roller {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
// @media screen and (min-width: 750px) {
//   .mobile {
//     display: none;
//   }
//   .pc {
//     overflow: hidden;
//   }
// }
// @media screen and (max-width: 750px) {
//   .pc {
//     display: none;
//   }
// }
</style>
